"use strict";
var globalThis = require("../internals/global-this");
var uncurryThis = require("../internals/function-uncurry-this-clause");
var fails = require("../internals/fails");
var aCallable = require("../internals/a-callable");
var internalSort = require("../internals/array-sort");
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var FF = require("../internals/environment-ff-version");
var IE_OR_EDGE = require("../internals/environment-is-ie-or-edge");
var V8 = require("../internals/environment-v8-version");
var WEBKIT = require("../internals/environment-webkit-version");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = globalThis.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function() {
  nativeSort(new Uint16Array(2), null);
}) && fails(function() {
  nativeSort(new Uint16Array(2), {});
}));
var STABLE_SORT = !!nativeSort && !fails(function() {
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;
  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;
  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }
  nativeSort(array, function(a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });
  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});
var getSortCompare = function(comparefn) {
  return function(x, y) {
    if (comparefn !== void 0) return +comparefn(x, y) || 0;
    if (y !== y) return -1;
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};
exportTypedArrayMethod("sort", function sort(comparefn) {
  if (comparefn !== void 0) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);
  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
